/**
 * useFormatPrice — shared price formatting utility.
 * Returns a function that formats a number/string to EUR currency.
 *
 * @returns {(value: number|string|null|undefined) => string}
 */
export function useFormatPrice() {
    return function formatPrice(value) {
        if (value == null || value === '') return '—';
        return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(value);
    };
}
